const route = {
	path: '/accounting-dictionary-ats',
	name: 'accounting-dictionary-ats',
	meta: {
		title: 'Diccionario de Datos Ats',
		noChangeCompany: true,
	},
	component: () => import('@/pages/atsDictionary/ats-list-dictionary'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/ats-list-dictionary.js